




































































































































































































































































import {
  Component,
  Mixins,
  Prop,
  Emit,
  Watch,
  Ref,
} from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";
import { Billing, DEFAULT_BILLING } from "@/model/agreement/billing";
import { VForm } from "@/types";

@Component
export default class BiDateEditDialog extends Mixins(
  AxiosMixin,
  RulesMixin,
  UtilMixin
) {
  /** ダイアログ開閉状態 */
  @Prop({ default: false }) private readonly value!: boolean;

  /** 事業所請求情報 */
  @Prop({ default: () => DEFAULT_BILLING }) private readonly billing!: Billing;

  /** 契約ID */
  @Prop({ default: 0 }) private readonly agreementId!: number;

  /** 入力フォーム */
  @Ref("bi-date-form") private readonly form!: VForm;

  /** 編集用の請求情報(コピー) */
  private editBilling: Billing = { ...DEFAULT_BILLING };

  /** 対象日(開始日・終了日への一括設定用) */
  private quickDate = "";

  /** 対象日ウォッチャーの一時抑制フラグ */
  private suppressQuickWatch = false;

  /** 一括操作(対象日設定/クリア)が行われたか(サマリ表示用) */
  private quickActionDone = false;

  /** 詳細設定(ON/OFF・各日付)の表示状態 */
  private showDetail = false;

  @Emit() private input(value: boolean) {
    return value;
  }

  private get Value(): boolean {
    return this.value;
  }
  private set Value(value: boolean) {
    this.input(value);
  }

  /** 保存後にiBowボードが有効になるか */
  private get isBiEnabled(): boolean {
    return this.editBilling.is_bi_enabled === 1;
  }

  /** サマリ表示用:開始日 */
  private get startDateDisp(): string {
    return this.formatDateDisp(this.editBilling.bi_start_date);
  }

  /** サマリ表示用:終了日 */
  private get endDateDisp(): string {
    return this.formatDateDisp(this.editBilling.bi_end_date);
  }

  /** yyyy-mm-dd を yyyy年mm月dd日 に整形(未設定は「未設定」) */
  private formatDateDisp(date: string): string {
    if (!date) {
      return "未設定";
    }
    const [year, month, day] = date.split("-");
    return `${year}年${month}月${day}日`;
  }

  /** ダイアログを開いたときに現在値で初期化 */
  @Watch("value") private onChangeValue(value: boolean) {
    if (value) {
      this.editBilling = { ...this.billing };
      this.quickDate = "";
      this.showDetail = false;
      this.quickActionDone = false;
      this.$nextTick(() => {
        if (this.form) {
          this.form.resetValidation();
        }
      });
    }
  }

  /**
   * 対象日の変更を開始日・終了日へ反映する。
   * 日付入力時は開始日=終了日=対象日にして機能をON、
   * クリア時は元の請求情報の値へ戻す(反映を取り消す)。
   */
  @Watch("quickDate") private onChangeQuickDate(date: string): void {
    if (this.suppressQuickWatch) {
      return;
    }
    if (date) {
      this.editBilling.bi_start_date = date;
      this.editBilling.bi_end_date = date;
      this.editBilling.is_bi_enabled = 1;
      this.quickActionDone = true;
    } else {
      // クリア(取り消し)時は元の値へ戻し、サマリも非表示に戻す
      this.editBilling.bi_start_date = this.billing.bi_start_date;
      this.editBilling.bi_end_date = this.billing.bi_end_date;
      this.editBilling.is_bi_enabled = this.billing.is_bi_enabled;
      this.quickActionDone = false;
    }
  }

  /** iBowボード機能をOFFにし、開始日・終了日をクリアする */
  private disableBi(): void {
    // 対象日をクリアするが、ウォッチャーによる元値復元は抑制する
    this.suppressQuickWatch = true;
    this.quickDate = "";
    this.editBilling.is_bi_enabled = 0;
    this.editBilling.is_biaggregate_enabled = 0;
    this.editBilling.bi_start_date = "";
    this.editBilling.bi_end_date = "";
    this.quickActionDone = true;
    this.$nextTick(() => {
      this.suppressQuickWatch = false;
      if (this.form) {
        this.form.resetValidation();
      }
    });
  }

  /** バリデーションチェック:開始日(機能ON時は必須) */
  private checkStartDate(date: string): boolean | string {
    if (this.editBilling.is_bi_enabled != 1) {
      return true;
    }
    if (!date) {
      return "必須項目です。";
    }
    return true;
  }

  /** バリデーションチェック:バンドル適用開始日(終了日のみ設定はNG) */
  private checkBundleStartDate(): boolean | string {
    if (
      !this.editBilling.bi_bundle_start_date &&
      this.editBilling.bi_bundle_end_date
    ) {
      return "バンドル適用開始日を入力してください。";
    }
    return true;
  }

  /** 保存 */
  private async save(): Promise<void> {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }

    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    // iBowボード項目を上書きしたBilling全体を送信する
    const billing: Billing = {
      ...this.editBilling,
      change_message: "iBowボード設定変更",
    };

    this.postJsonCheck(
      window.base_url + "/api/admin/billing_info/save",
      {
        billing: billing,
        agreement_id: this.agreementId,
        saving_confflag: 1,
        is_office_info_update: false,
        office_info: null,
      },
      () => {
        this.$emit("saved");
        this.close();
      }
    );
  }

  /** ダイアログを閉じる */
  private close(): void {
    this.input(false);
  }

  /** オプション系リセット */
  private resetOption() {
    if (!this.editBilling.is_bi_enabled) {
      this.editBilling.is_biaggregate_enabled = 0;
    }
  }
}
